module.exports = __webpack_public_path__ + "img/giordano-courtage.aaabcc31.svg";